<div [formGroup]="form">
  <mat-form-field>
    <mat-label>Zip code</mat-label>
    <input matInput type="number" min="0" max="99999" step="1" formControlName="zip" required />
    <mat-error *ngIf="form.get('zip').hasError('required')">
      The zip code field is required.
    </mat-error>
  </mat-form-field>
</div>
